.Report-class {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0;
  flex-direction: column;
  box-sizing: border-box;
  border: none !important;
  overflow: hidden;
}

.Report-class iframe {
  border: none !important;
}